import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../assets/styles/footerfiles.css";
import { useNavigate } from "react-router-dom";

function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-white">
      <Navbar
        scrollPast={true}
        hidePanel={true}
        hideSignIn={true}
        lockNavbar={true}
      />

      <div className="max-w-[1000px] mx-auto px-4 md:px-8 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Sobre Laburo
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Transformando el reclutamiento con tecnología innovadora y accesible
          </p>
        </div>

        {/* Main Content */}
        <div className="space-y-16">
          {/* Introduction */}
          <section className="bg-white p-8 rounded-xl shadow-[0_4px_24px_-4px_rgba(0,0,0,0.03)] border border-gray-100">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              ¿Quiénes Somos?
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Laburo es un sistema de seguimiento de candidatos (ATS) moderno,
              ágil y fácil de usar. Diseñado para transformar la manera en que
              las empresas gestionan su proceso de reclutamiento y selección,
              simplificando cada paso del camino.
            </p>
          </section>

          {/* Mission */}
          <section className="bg-gray-900 p-8 rounded-xl shadow-[0_4px_24px_-4px_rgba(0,0,0,0.03)]">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Nuestra Misión
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              Reducir la ineficiencia en las organizaciones mediante soluciones
              tecnológicas innovadoras y accesibles que empoderen a las empresas
              a gestionar su talento humano de manera más efectiva.
            </p>
          </section>

          {/* Vision */}
          <section className="bg-white p-8 rounded-xl shadow-[0_4px_24px_-4px_rgba(0,0,0,0.03)] border border-gray-100">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Nuestra Visión
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Convertirnos en un ecosistema de recursos humanos que permita a
              las empresas de todos los tamaños implementar las mejores
              prácticas y mejorar su eficiencia operativa.
            </p>
          </section>

          {/* Call to Action */}
          <section className="text-center">
            <button
              onClick={() => navigate("/empresas")}
              className="inline-flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white transition-all duration-300 text-[14px] py-3 px-6 rounded-xl hover:translate-y-[-1px] active:translate-y-[1px] font-medium tracking-wide group"
            >
              <span>Conoce más sobre Laburo</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </section>
        </div>
      </div>

      <Footer type={2} />
    </div>
  );
}

export default AboutUs;
